// global.constants = {
//     mobileRegex:/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/, //国内手机号正则表达式
//     telRegex:/0\d{2,3}-\d{7,8}/,    //国内座机正则表达式
// };

// const mobileRegex=/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7,9]))\d{8}$/;
const isNum = /^(?:0|[1-9][0-9]*)$/;
const mobileRegex = /^1\d{10}$/;
const telRegex = /0\d{2,3}-\d{7,8}/;
const telOrMobileRegex = /^(1\d{10})$|^(0\d{2,3}-\d{7,8})$/;
const spaceRegex = /^\S(\S|\s)*\S$/g;
const idCardRegex =
  /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1−9]\d5\d2((0[1−9])|(10|11|12))(([0−2][1−9])|10|20|30|31)\d2[0−9Xx])|([1−9]\d5\d2((0[1−9])|(10|11|12))(([0−2][1−9])|10|20|30|31)\d2[0−9Xx])/;
// const BaseUrl = 'https://hofapi.realmadrid.fun';
// const BaseUrl = 'http://hof.tt.jyapi.cn';
// const BaseUrl = "https://pl-hofapi.rldmcd.com"; // 正式环境1
// const BaseUrl = "//pl-hof2023-api.rldmcd.com"; // 正式环境2
// const BaseUrl = "//pl-hof-api.mavs.top"; // 正式环境2
const BaseUrl = "//pl-hof-api.rldm-cd.com"; // 正式环境2
// const BaseUrl = "https://hofapi.dev.rldmcd.com"; // 测试环境
// const UploadBaseUrl = 'http://hof.tt.jyapi.cn/common/singleUpload';
// const UploadBaseUrl = "https://pl-hofapi.rldmcd.com/common/singleUpload";  // 正式环境1
// const UploadBaseUrl = "//pl-hof2023-api.rldmcd.com/common/singleUpload"; // 正式环境2
// const UploadBaseUrl = "//pl-hof-api.mavs.top/common/singleUpload"; // 正式环境2
const UploadBaseUrl = "//pl-hof-api.rldm-cd.com/common/singleUpload"; // 正式环境2
// const UploadBaseUrl = "https://hofapi.dev.rldmcd.com/common/singleUpload"; // 测试环境
// const UploadBaseUrl = 'https://hofapi.realmadrid.fun/common/singleUpload';

//上传接受类型  参考 https://blog.csdn.net/ssgo66/article/details/83621798
const commonUploadType =
  ".xls,.xlsx," + "application/vnd.ms-excel    MS Excel Spreadsheet,";

export {
  isNum,
  mobileRegex,
  telRegex,
  telOrMobileRegex,
  spaceRegex,
  idCardRegex,
  BaseUrl,
  UploadBaseUrl,
  commonUploadType,
};



// WEBPACK FOOTER //
// ./src/utils/globalConst.js